<script>
import { required } from "vuelidate/lib/validators";
import { layoutMethods, erpUserRolesMethods, exportMethods, coreEloadDropdownMethods, coreEloadDropdownComputed, coreEloadSKUMasterMethods, coreEloadSKUMasterComputed } from '@/state/helpers';
import Swal from 'sweetalert2';
import { getModuleAccess } from '@/router/helper.js'
import Multiselect from "vue-multiselect";

/**
 * E-Load list component
 */
export default {
  page: {
    title: "E-Load SKU Master Form",
  },
  data() {
    return {
      promoId: 0,
      eload: {
        promoId: "",
        name: "",
        code: "",
        validity: "",
        amount: "",
        description: "",
        provider: null,
        networkGroup: null,
        category: "",
        categoryIds: [],
        categoryNames: [],
        status: 1,
        service: null,
        error: "",
        input_type: null,
        minimum: null,
        maximum: null,
      },
      formExitChecker : {
        promoId: "",
        name: "",
        code: "",
        validity: "",
        amount: "",
        description: "",
        provider: null,
        networkGroup: null,
        category: "",
        categoryIds: [],
        categoryNames: [],
        status: 1,
        service: null,
        error: "",
        input_type: null,
        minimum: null,
        maximum: null,
      },
      options: [
        { value: "GLOBE", text: "Globe" },
        { value: "TM", text: "TM" },
        { value: "SMART", text: "Smart" },
        { value: "DITO", text: "DITO" },
      ],
      submitted: false,
      eloadPromoModule: {
        access: {
          create: true,
          update: true
        }
      },
      categoryList: [],
      eloadServiceOptions: [],
      providerList: [],
      eloadNetworkGroupOptions: [],
      inputTypeList: [
        { value: null, text: 'Select Input Type', disabled: true },
        { value: "MN", text: 'Mobile Number'},
        { value: "AN", text: 'Account Number'}
      ],
      inputTypeHandler: null,
    };
  },
  validations: {
    eload: {
      name: {required},
      code: {required},
      validity: {required},
      amount: {required},
      description: {required},
      provider: {required},
      status: {required},
      category: {required},
      networkGroup: {required},
      service: {required},
      input_type: {required}
    }
  },
  components: {
    Multiselect
  },
  computed: {
    ...coreEloadDropdownComputed,
    ...coreEloadSKUMasterComputed,
    selectedCategory: {
        get() {
          // Single selection - return the category object or null
          if (this.eload.categoryNames && this.eload.categoryNames.length > 0) {
            const categoryName = this.eload.categoryNames[0];
            
            // Check if it's from the predefined list
            const foundCategory = this.categoryList.find(cat => cat.value === categoryName);
            if (foundCategory) {
              return foundCategory;
            }
            
            // It's a custom category
            return { id: 'custom', text: categoryName, value: categoryName };
          }
          return null;
        },
        set(category) {
          if (category) {
            // Single category selection
            this.eload.categoryIds = [category.id];
            this.eload.categoryNames = [category.value];
            this.eload.category = category.value;
          } else {
            // Clear selection
            this.eload.categoryIds = [];
            this.eload.categoryNames = [];
            this.eload.category = "";
          }
        },
      },
    
  },
  mounted: async function() {
    this.promoId = this.$route.params.id;
        
    // if(this.promoId == 0) { // Disable Create Eload promo page - PEDDLR-6704
    //   this.$router.push(
    //       this.$route.query.redirectFrom || {
    //         name: "E-Load",
    //       }
    //     );
    //     return;
    // }

    
    this.getEloadCategoryList();
    this.getEloadServiceList();
    this.getEloadProviderList();
    this.getNetworkGroups();
    

    this.changeTitle({title: (this.promoId > 0 ? "Edit" : "Add") + ' E-Load SKU Master'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: 'Peddlr', to: { name: 'Home'}},
        { text: 'E-Load Core Manager', to: { name: 'E-Load Core SKU Master'} },
        { text: 'E-Load SKU Master Form', to: { name: 'E-Load Core SKU Master Form'} }
      ]
    });
    if (this.promoId > 0) {
      await this.editPromo();
    }

    await getModuleAccess('Products', 'eLoad', 'eLoad Promo')
      .then((access) => this.eloadPromoModule.access = access);
  },
  methods: {
    ...layoutMethods,
    ...erpUserRolesMethods,
    ...coreEloadDropdownMethods,
    ...coreEloadSKUMasterMethods,
    ...exportMethods,
    async getEloadProviderList() {
        this.fetchCoreProvidersList().then(async () => {
          let sortedList = await this.sortOptions('name', [...this.getCoreProvidersList]);
          for (let provider of sortedList) {
            this.providerList.push({ text: provider.name, value: provider.name })
          }
        });
    },
    async getEloadCategoryList() {
      this.fetchCoreCategoriesList().then(async () => {
        let sortedList = await this.sortOptions('category', [...this.getCoreCategoriesList]);
        for(let data of sortedList){
          this.categoryList.push({ 'text': data.category, 'value': data.category })
        }
      })
    },
     async getEloadServiceList() {
      this.fetchCoreServicesList().then(async () => {
        let sortedList = await this.sortOptions('service', [...this.getCoreServicesList]);
        for (let service of sortedList) {
          this.eloadServiceOptions.push({ text: service.service, value: service.service })
        }
      });
    },
    async getNetworkGroups() {
      this.fetchCoreNetworksList().then(async () => {
        let sortedList = await this.sortOptions('name', JSON.parse(JSON.stringify(this.getCoreNetworksList)));
        for (let group of sortedList) {
          this.eloadNetworkGroupOptions.push({ text: group.name, value: group.name })
        }
      });
    },
    async handleSubmit() {
      var action = this.promoId == 0 ? "create":"update";
      this.submitted = true
      this.$v.$touch();
      
      //this will handle the validation of account number
      if(this.eload.input_type == "AN"){
        try {
          if(!isNaN(parseInt(this.eload.minimum)) && !isNaN(parseInt(this.eload.maximum))){
            if(parseInt(this.eload.minimum) < parseInt(this.eload.maximum)){
              this.inputTypeHandler = null
            } else{
              this.inputTypeHandler = "Minimum should be less than maximum"
            }
          }else{
            this.inputTypeHandler = "This field is required"
          }
          if(this.inputTypeHandler != null){
            return;
          }
        } catch (error) {
          Swal.fire(
            ((action == 'create') ? "Create":"Update")+" Failed!",
            error,
            "warning"
          );
          return 
        }
      }

      if (!this.$v.eload.$invalid){
        let status = this.eload.status ? 1 : 0
        let serviceProviderId = this.getCoreProvidersList.find(p => p.name.trim() == this.eload.provider) ? this.getCoreProvidersList.find(p => p.name.trim() == this.eload.provider).id : null

        let body = {
          id: action == "create" ? null : String(this.eload.promoId),
          skuName: this.eload.name,
          service: this.eload.service,
          description: this.eload.description,
          validity: this.eload.validity,
          category: this.eload.category,
          amount: String(this.eload.amount),
          skuStatus: String(status),
          skuCode: this.eload.code,
          serviceGroup: this.eload.networkGroup,
          serviceProvider: String(serviceProviderId),
          addressMin: this.eload.minimum == null ? "11" : String(this.eload.minimum),
          addressMax: this.eload.maximum == null ? "11" : String(this.eload.maximum),
          addressType: this.eload.input_type
        };

        this.actionCoreEloadSKUMasterAPIPOST({
          action: action,
          params: body
        })
          .then(() => {
            this.submitted = false
            this.clearForm();
            var applied_action = (action == 'create') ? "created" : "updated";
            Swal.fire(
               ((action == 'create') ? "Create":"Update")+" Successful!",
              `${body.skuName} is successfully ${applied_action}.`,
              "success"
            ).then(() => {
              this.$router.go(-1);
              return;
            });
          })
          .catch((error) => {
            console.log(error);
            this.$alertify.error(error && error.message ? error.message : error);
            Swal.fire(
              ((action == 'create') ? "Create":"Update")+" Failed!",
              error,
              "warning"
            );
            this.submitted = false
            return;
          });
      }
      else {
        this.$alertify.error("Unable to submit, please check the required fields and try again.");
        return;
      }
    },
    async editPromo() {
      await this.actionCoreEloadSKUMasterAPIPOST({action: "info", params: {"skuId" : this.promoId}}).then((response) => {
        const data = response.message;
        
        this.eload.promoId = data.skuId
        this.eload.name = data.skuName
        this.eload.code = data.skuCode
        this.eload.amount = data.skuAmount
        this.eload.description = data.skuDescription
        this.eload.validity = data.skuValidity
        this.eload.status = parseInt(data.skuStatus) === 1
        this.eload.category = data.skuCategory
        this.eload.categoryIds = []
        this.eload.categoryNames = [data.skuCategory]
        this.eload.networkGroup = data.serviceGroup
        this.eload.service = data.skuService
        this.eload.input_type = data.addressType
        this.eload.minimum = data.minimum
        this.eload.maximum = data.maximum
        
        // Find provider name from provider ID
        const providerObj = this.getCoreProvidersList.find(p => p.id === data.provider);
        this.eload.provider = providerObj ? providerObj.name : null;

        this.formExitChecker.promoId = data.skuId
        this.formExitChecker.name = data.skuName
        this.formExitChecker.code = data.skuCode
        this.formExitChecker.amount = data.skuAmount
        this.formExitChecker.description = data.skuDescription
        this.formExitChecker.validity = data.skuValidity
        this.formExitChecker.provider = providerObj ? providerObj.name : null
        this.formExitChecker.status = parseInt(data.skuStatus) === 1
        this.formExitChecker.category = data.skuCategory
        this.formExitChecker.categoryIds = []
        this.formExitChecker.categoryNames = [data.skuCategory]
        this.formExitChecker.networkGroup = data.serviceGroup 
        this.formExitChecker.service = data.skuService
        this.formExitChecker.input_type = data.addressType
        this.formExitChecker.minimum = data.minimum
        this.formExitChecker.maximum = data.maximum

        console.log(">> API Response:",response);
        console.log(">> Parsed Data:",data);
        console.log(">> eload:",this.eload);
        console.log(">> formExitChecker:",this.formExitChecker);
      });
    },
    leaveform(next){
        if(JSON.stringify(this.eload) == JSON.stringify(this.formExitChecker)){
          next();
          return;
        }
        Swal.fire({
            title: 'Are you sure?',
            text: "you want to leave this page?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '##804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                next();
            }else{
                return;
            }
        })
    },
    clearForm(){
      this.eload = {
        promoId: "",
        name: "",
        code: "",
        validity: "",
        amount: "",
        description: "",
        provider: null,
        networkGroup: null,
        category: "",
        categoryIds: [],
        categoryNames: [],
        status: 0,
        service: null,
        error: "",
        input_type: null,
        minimum: null,
        maximum: null,
      }
      this.formExitChecker = this.eload;
    },
    async sortOptions(propName, arr) {
      arr.sort((a, b) => {
        const nameA = a[`${propName}`].toUpperCase();
        const nameB = b[`${propName}`].toUpperCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      return arr;
    },
    getSelectedInputType(type){
      console.log(": getSelectedInputType :",type);
    },
    addCustomCategory(newCategory) {
      // Create a custom category object
      const customCat = {
        id: 'custom',
        text: newCategory,
        value: newCategory
      };
      
      // Set it as the selected category
      this.selectedCategory = customCat;
    }
  },
  beforeRouteLeave(to, from, next) {
      if(this.promoId > 0) {
        console.log("><><><><> HEY",JSON.stringify(this.eload),JSON.stringify(this.formExitChecker));
        this.leaveform(next);
      }
      else next(); // Disable create page for eload promo - PEDDLR-6704
  }
};
</script>

<template>
  <div class="row sku-master-form-page">
    <div class="col-lg-8">
      <div class="card">
        <div class="card-body">
          <form class="px-4 py-3" @submit.prevent="handleSubmit()">
            <div class="row">
              <label v-if="(promoId <= 0 || isNaN(promoId)) && !eloadPromoModule.access.create" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot create a promo.</label>
              <label v-else-if="promoId > 0 && !eloadPromoModule.access.update" class="form-label medium fw-bold text-danger mb-3">Note: Your access is limited. You cannot update a promo.</label>
            </div>
            
            <!-- Activate Toggle -->
            <div class="row mb-3">
              <div class="col-12">
                <div class="form-check form-switch form-switch-lg" dir="ltr">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="customSwitchsizem"
                    v-model="eload.status"
                  />
                  <label class="form-check-label form-label fw-bold" for="customSwitchsizem">Active</label>
                </div>
              </div>
            </div>

            <!-- Service and Network Row -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label fw-bold">Service<span style="color: red">*</span></label>
                <b-form-select
                  v-model="eload.service"
                  :options="eloadServiceOptions"
                  class="form-select shadow-none"
                  :class="{'is-invalid': submitted && $v.eload.service.$error}">
                  <template #first>
                    <b-form-select-option :value="null" disabled>Select Service</b-form-select-option>
                  </template>
                </b-form-select>
                <div v-if="submitted && $v.eload.service.$error" class="text-danger">
                  <span v-if="!$v.eload.service.required">Service is required.</span>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label fw-bold">Network<span style="color: red">*</span></label>
                <b-form-select
                  v-model="eload.networkGroup"
                  :options="eloadNetworkGroupOptions"
                  class="form-select shadow-none"
                  :class="{'is-invalid': submitted && $v.eload.networkGroup.$error}">
                  <template #first>
                    <b-form-select-option :value="null" disabled>Select Network</b-form-select-option>
                  </template>
                </b-form-select>
                <div v-if="submitted && $v.eload.networkGroup.$error" class="text-danger">
                  <span v-if="!$v.eload.networkGroup.required">Network is required.</span>
                </div>
              </div>
            </div>

            <!-- Provider and Category Row -->
            <div class="row">
              <div class="col-md-12 mb-3">
                <label class="form-label fw-bold">Provider<span style="color: red">*</span></label>
                <b-form-select
                  v-model="eload.provider"
                  :options="providerList"
                  class="form-select shadow-none"
                  :class="{'is-invalid': submitted && $v.eload.provider.$error}">
                  <template #first>
                    <b-form-select-option :value="null" disabled>Select Provider</b-form-select-option>
                  </template>
                </b-form-select>
                <div v-if="submitted && $v.eload.provider.$error" class="text-danger">
                  <span v-if="!$v.eload.provider.required">Provider is required.</span>
                </div>
              </div>

              <div class="col-md-12 mb-3">
                <label class="form-label fw-bold">Category<span style="color: red">*</span></label>
                <multiselect
                  v-model="selectedCategory"
                  :options="categoryList"
                  track-by="value"
                  label="text"
                  name="selectCategory"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  placeholder="Select Category or type to add custom"
                  :allow-empty="true"
                  :taggable="true"
                  :show-labels="false"
                  tag-placeholder="Press enter to create"
                  @tag="addCustomCategory"
                  @remove="selectedCategory = null"
                  :class="{'is-invalid': submitted && $v.eload.category.$error}">
                  <template slot="singleLabel" slot-scope="{ option }">
                    <span class="multiselect__single">
                      {{ option.text }}
                      <span class="multiselect__tag-divider"></span>
                      <i class="multiselect__tag-icon" @mousedown.prevent.stop="selectedCategory = null"></i>
                    </span>
                  </template>
                </multiselect>
                <div v-if="submitted && !$v.eload.category.required" class="invalid-feedback">
                  Category is required.
                </div>
              </div>
            </div>

            <!-- Promo Name and Promo Code Row -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label fw-bold">Promo Name<span style="color: red">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-model="eload.name"
                  placeholder="Enter Promo Name"
                  :class="{'is-invalid': submitted && $v.eload.name.$error}"/>
                <div v-if="submitted && !$v.eload.name.required" class="invalid-feedback">
                  Promo Name is required.
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label fw-bold">Promo Code<span style="color: red">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-model="eload.code"
                  placeholder="Enter Promo Code"
                  :class="{'is-invalid': submitted && $v.eload.code.$error}"/>
                <div v-if="submitted && !$v.eload.code.required" class="invalid-feedback">
                  Promo Code is required.
                </div>
              </div>
            </div>

            <!-- Input Type Row -->
            <div class="row">
              <div class="col-md-12 mb-3">
                <label class="form-label fw-bold">Input Type<span style="color: red">*</span></label>
                <b-form-select
                  v-model="eload.input_type"
                  :options="inputTypeList"
                  class="form-select shadow-none"
                  v-on:change="getSelectedInputType"
                  :class="{'is-invalid': submitted && $v.eload.input_type.$error}">
                </b-form-select>
                <div v-if="submitted && !$v.eload.input_type.required" class="invalid-feedback">
                  Input Type is required.
                </div>
              </div>
            </div>

            <!-- Min and Max Number Row -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <input
                  type="number"
                  class="form-control"
                  v-model="eload.minimum"
                  placeholder="Min Number"
                  :class="{'is-invalid': submitted && inputTypeHandler != null}"
                  :disabled="eload.input_type == 'MN' || eload.input_type == null"/>
                <div v-if="submitted && inputTypeHandler != null" class="invalid-feedback">
                  {{inputTypeHandler}}
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <input
                  type="number"
                  class="form-control"
                  v-model="eload.maximum"
                  placeholder="Max Number"
                  :class="{'is-invalid': submitted && inputTypeHandler != null}"
                  :disabled="eload.input_type == 'MN' || eload.input_type == null"/>
              </div>
            </div>

            <!-- Amount and Validity Row -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label fw-bold">Amount<span style="color: red">*</span></label>
                <input
                  type="number"
                  step="0.01"
                  class="form-control"
                  v-model="eload.amount"
                  placeholder="Enter Load Amount"
                  :class="{'is-invalid': submitted && $v.eload.amount.$error}"/>
                <div v-if="submitted && !$v.eload.amount.required" class="invalid-feedback">
                  Load Amount is required.
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label fw-bold">Validity<span style="color: red">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  v-model="eload.validity"
                  placeholder="Enter Duration / Days"
                  :class="{'is-invalid': submitted && $v.eload.validity.$error}"/>
                <div v-if="submitted && !$v.eload.validity.required" class="invalid-feedback">
                  Duration / Days is required.
                </div>
              </div>
            </div>

            <!-- Description Row -->
            <div class="row">
              <div class="col-md-12 mb-3">
                <label class="form-label fw-bold">Description<span style="color: red">*</span></label>
                <b-form-textarea
                  v-model="eload.description"
                  placeholder="Enter promo description..."
                  rows="3"
                  max-rows="6"
                  :class="{'is-invalid': submitted && $v.eload.description.$error}">
                </b-form-textarea>
                <div v-if="submitted && !$v.eload.description.required" class="invalid-feedback">
                  Description is required.
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="text-end mt-4">
              <b-button 
                :disabled="promoId > 0 ? !this.eloadPromoModule.access.update : !this.eloadPromoModule.access.create" 
                variant="primary" 
                class="w-sm" 
                type="submit">
                  {{promoId > 0 ? 'Update':'Save'}}
              </b-button>
              <router-link :to="{ name: 'E-Load Core SKU Master', params: {} }" class="tc-white">
                <b-button variant="light" class="w-sm ms-2" type="button">Cancel</b-button>
              </router-link>
              <p v-if="eload.error" class="text-danger">{{ eload.error }}</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.sku-master-form-page .disabled-text {
  color: gray;
}

/* Make multiselect show red border when invalid */
.sku-master-form-page .multiselect.is-invalid .multiselect__tags {
  border-color: #dc3545 !important;
}

/* Show the invalid feedback below multiselect */
.sku-master-form-page .multiselect.is-invalid ~ .invalid-feedback {
  display: block;
}

/* Style for single selection tag with remove button */
.sku-master-form-page .multiselect--active .multiselect__tags {
  padding: 8px 40px 8px 8px;
}

.sku-master-form-page .multiselect__tags {
  min-height: 45px;
  display: flex;
  align-items: center;
  padding: 8px;
}

.sku-master-form-page .multiselect__single {
  background: #804997;
  color: white;
  padding: 2px 5px 2px 5px;
  border-radius: 4px;
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  position: relative;
  min-height: auto;
  line-height: 1.4;
  width: fit-content;
  max-width: 100%;
}

.sku-master-form-page .multiselect__tags-wrap {
  display: inline-flex;
  align-items: center;
}

/* Vertical divider line before X button */
.sku-master-form-page .multiselect__tag-divider {
  display: inline-block;
  width: 1px;
  height: 18px;
  background-color: rgba(255, 255, 255, 0.3);
  margin: 0 0px 0 8px;
}

/* Remove button (X) styling */
.sku-master-form-page .multiselect__tag-icon {
  position: relative;
  cursor: pointer;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  border-radius: 50%;
  background: transparent;
  transition: background 0.2s ease;
  right: auto;
  top: auto;
  transform: none;
  /* margin-right: 2px; */
}

.sku-master-form-page .multiselect__tag-icon:after {
  content: "×";
  color: white;
  font-size: 20px;
  font-weight: bold;
  line-height: 18px;
}

.sku-master-form-page .multiselect__tag-icon:hover {
  background: transparent;
}

.sku-master-form-page .multiselect__tag-icon:focus {
  outline: none;
}

/* Adjust placeholder when no selection */
.sku-master-form-page .multiselect__placeholder {
  color: #6c757d;
  margin-bottom: 0;
  padding-top: 0;
  display: inline-block;
  padding-left: 4px;
}

/* Hide the dropdown arrow when there's a selection for cleaner look */
.sku-master-form-page .multiselect__select {
  right: 8px;
  width: 30px;
  height: 30px;
  top: 50%;
  transform: translateY(-50%);
}
</style>